














































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {FILE_GET, FILE_UPLOAD, HUNTING_LICENSE_ORDERS, HUNTING_TICKET_ORDERS} from '@/common/api';
import {AxiosResponse, AxiosError} from 'axios';
import {QScrollArea} from 'quasar';
import {saveFileFromResponse} from "@/common/helpers";

@Component<HuntingLicenseMessage>({
  name: 'HuntingLicenseMessage',
  props: {
    isReadonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true,
    },
  },
})
export default class HuntingLicenseMessage extends Vue {
  id!: number

  newMessage: string = '';

  messages: Array<any> = []

  isFilesModalOpen = false;

  watchAttachments = false;

  attachmentsToWatch = [];

  attachments: Array<{ id: string, name: string }> = [];

  $refs!: {
    chat: QScrollArea,
    formData: any;
  }

  aufHeaders = [
    {name: 'Authorization', value: `Bearer ${this.$store.state.auth.token}`},
  ];

  sendMessage() {
    if (this.newMessage === '') return;
    const data = {
      text: this.newMessage,
      attachments: this.attachments.map((attachment) => attachment.id),
    };
    this.$http({...HUNTING_LICENSE_ORDERS.SEND_MESSAGE(this.id), data}).then((r) => {
      this.messages.push(r.data);
      this.newMessage = '';
      this.$s.notify.success('Сообщение в одереди на отправку в ЕПГУ');
      this.scrollDown();
    }).finally(() => {
      this.$s.loading.hide();
      this.attachments = [];
    });
  }

  // eslint-disable-next-line class-methods-use-this
  uploaderFactory() {
    return FILE_UPLOAD;
  }

  truncate(text: string, length: number = 20): string {
    if (!text) return '';

    if (text.length <= length) {
      return text;
    }
    return `${text.substr(0, length)} ...`;
  }

  refresh() {
    this.$s.loading.show();
    this.$http({...HUNTING_LICENSE_ORDERS.GET_MESSAGES(this.id)}).then((r) => {
      this.messages = r.data;
      this.scrollDown();
    }).finally(() => {
      this.$s.loading.hide();
    });
  }

  scrollDown() {
    this.$nextTick(() => {
      this.$refs.chat.setScrollPosition(this.$refs.chat.getScrollTarget().scrollHeight, 500);
    });
  }

  mounted() {
    this.$debug('mounted');
    this.refresh();
  }

  files() {
    this.isFilesModalOpen = !this.isFilesModalOpen;
  }

  watch_message_attachments(message): void {
    this.watchAttachments = true;
    this.attachmentsToWatch = message.attachments;
  }

  closeMessageAttachments(): void {
    this.watchAttachments = false;
  }

  addIds({xhr: {response}}) {
    this.attachments.push(JSON.parse(response) as never);
  }

  removeAttachment(index: number): void {
    this.attachments.splice(index, 1);
  }

  downloadFile(fileId: string): void {
    if (fileId.length === 36 && (fileId.match(/-/g) || []).length === 4) {
      try {
        this.$http.request({...FILE_GET(fileId), responseType: 'blob'})
          .then((response) => {
          saveFileFromResponse(response);
        })
      } finally {
      }
    } else {
      window.open(fileId, '_BLANK');
    }
  }

}

